import React, { useEffect, useState } from "react";

export default function AdminDashboard() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [editingUser, setEditingUser] = useState(null);
 

  // Fetch users from API
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/users`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        const data = await res.json();
        if (res.ok) {
          setUsers(data.users || []);
        } else {
          setError(data.message || "Failed to fetch users.");
        }
      } catch (err) {
        console.error("Error fetching users:", err);
        setError("Network error.");
      }
      setLoading(false);
    };
    fetchUsers();
  }, []);

  // Delete user
  const handleDelete = async (userId) => {
    if (!window.confirm("Are you sure you want to delete this user?")) return;
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/users/${userId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (res.ok) {
        setUsers(users.filter((u) => u.id !== userId));
      } else {
        setError("Failed to delete user.");
      }
    } catch {
      setError("Network error.");
    }
  };

  const [editForm, setEditForm] = useState({
    name: "",
    role: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    country: "",
    specialization: "",
    bio: "",
    image: null,
  });

  // Start editing
  const handleEdit = (user) => {
    setEditingUser(user);
    setEditForm({
        name: user.name || "",
        role: user.role?.name || user.role || "",
        phone: user.profile?.phone || "",
        address: user.profile?.address || "",
        city: user.profile?.city || "",
        state: user.profile?.state || "",
        country: user.profile?.country || "",
        specialization: user.profile?.specialization || "",
        bio: user.profile?.bio || "",
        image: null,
    });
};

  // Handle edit form change
  const handleEditChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image") {
      setEditForm({ ...editForm, image: files[0] });
    } else {
      setEditForm({ ...editForm, [name]: value });
    }
  };

  // Update user
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!editingUser) return;
    try {
      const token = localStorage.getItem("token");
      const formData = new FormData();
      Object.entries(editForm).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
          formData.append(key, value);
        }
      });
  
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/users/${editingUser.id}/profile`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
          body: formData,
        }
      );
      if (res.ok) {
        setEditingUser(null);
        setEditForm({
          name: "",
          role: "",
          phone: "",
          address: "",
          city: "",
          state: "",
          country: "",
          specialization: "",
          bio: "",
          image: null,
        });
        // Optionally refetch users here
      } else {
        setError("Failed to update user.");
      }
    } catch {
      setError("Network error.");
    }
  };

  // Cancel editing
  const handleCancelEdit = () => {
    setEditingUser(null);
    setEditForm({ name: "", role: "" });
  };

  return (
    <div className="p-8">
      <h2 className="text-2xl font-bold mb-4">Admin Dashboard</h2>
      <h3 className="text-lg font-semibold mb-2">Manage Users</h3>
      {(() => {
        if (loading) {
          return <div>Loading users...</div>;
        }
        if (error) {
          return <div className="text-red-600">{error}</div>;
        }
        return (
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white rounded shadow">
              <thead>
                <tr>
                  <th className="px-4 py-2 border">ID</th>
                  <th className="px-4 py-2 border">Name</th>
                  <th className="px-4 py-2 border">Email</th>
                  <th className="px-4 py-2 border">Role</th>
                  <th className="px-4 py-2 border">Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) =>
                  editingUser && editingUser.id === user.id ? (
                    <tr key={user.id}>
                        <td className="px-4 py-2 border">{user.id}</td>
                        <td className="px-4 py-2 border">
                        <input
                            type="text"
                            name="name"
                            value={editForm.name}
                            onChange={handleEditChange}
                            className="border rounded px-2 py-1"
                        />
                        </td>
                        <td className="px-4 py-2 border">{user.email}</td>
                        <td className="px-4 py-2 border">
                        <select
                            name="role"
                            value={editForm.role}
                            onChange={handleEditChange}
                            className="border rounded px-2 py-1"
                        >
                            <option value="admin">Admin</option>
                            <option value="lawyer">Lawyer</option>
                            <option value="client">Client</option>
                        </select>
                        </td>
                        <td className="px-4 py-2 border">
                        <input
                            type="text"
                            name="phone"
                            value={editForm.phone}
                            onChange={handleEditChange}
                            placeholder="Phone"
                            className="border rounded px-2 py-1 mb-1"
                        />
                        <input
                            type="text"
                            name="address"
                            value={editForm.address}
                            onChange={handleEditChange}
                            placeholder="Address"
                            className="border rounded px-2 py-1 mb-1"
                        />
                        <input
                            type="text"
                            name="city"
                            value={editForm.city}
                            onChange={handleEditChange}
                            placeholder="City"
                            className="border rounded px-2 py-1 mb-1"
                        />
                        <input
                            type="text"
                            name="state"
                            value={editForm.state}
                            onChange={handleEditChange}
                            placeholder="State"
                            className="border rounded px-2 py-1 mb-1"
                        />
                        <input
                            type="text"
                            name="country"
                            value={editForm.country}
                            onChange={handleEditChange}
                            placeholder="Country"
                            className="border rounded px-2 py-1 mb-1"
                        />
                        <input
                            type="text"
                            name="specialization"
                            value={editForm.specialization}
                            onChange={handleEditChange}
                            placeholder="Specialization"
                            className="border rounded px-2 py-1 mb-1"
                        />
                        <textarea
                            name="bio"
                            value={editForm.bio}
                            onChange={handleEditChange}
                            placeholder="Bio"
                            className="border rounded px-2 py-1 mb-1"
                        />
                        <input
                            type="file"
                            name="image"
                            accept="image/*"
                            onChange={handleEditChange}
                            className="border rounded px-2 py-1 mb-1"
                        />
                        <div className="flex gap-2 mt-2">
                            <button
                            className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-800 mr-2"
                            onClick={handleUpdate}
                            >
                            Save
                            </button>
                            <button
                            className="bg-gray-400 text-white px-3 py-1 rounded hover:bg-gray-600"
                            onClick={handleCancelEdit}
                            >
                            Cancel
                            </button>
                        </div>
                        </td>
                    </tr>
                    ) : (
                    <tr key={user.id}>
                      <td className="px-4 py-2 border">{user.id}</td>
                      <td className="px-4 py-2 border">{user.name}</td>
                      <td className="px-4 py-2 border">{user.email}</td>
                      <td className="px-4 py-2 border">{user.role?.name || user.role || ""}</td>
                      <td className="px-4 py-2 border">
                        <button
                          className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-700 mr-2"
                          onClick={() => handleEdit(user)}
                        >
                          Edit
                        </button>
                        <button
                          className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-800"
                          onClick={() => handleDelete(user.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  )
                )}
                {users.length === 0 && (
                  <tr>
                    <td colSpan={5} className="text-center py-4">
                      No users found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        );
      })()}
    </div>
  );
}